var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-results"},[_vm._v("\n  No results, try something else\n")])}
var staticRenderFns = []

export { render, staticRenderFns }